import { Component, OnInit } from '@angular/core';
import { AppSettings } from '../../../app-settings'


@Component({
  selector: 'supplier-event-detail',
  templateUrl: './event-detail.component.html',
  styleUrls: ['./event-detail.component.css']
})
export class SupplierEventDetailComponent implements OnInit {

  CONTACT_EMAIL = AppSettings.CONTACT_EMAIL
  CONTACT_NAME = AppSettings.CONTACT_NAME

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /var/www/html/nissco_event_web/angular/src/app/supplier/profile/event-detail/event-detail.component.ts